import { render } from "./pod.vue?vue&type=template&id=23a35486"
import script from "./pod.vue?vue&type=script&lang=js"
export * from "./pod.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__